import React from 'react';
import './TestimonialsSection.scss';
import bobSmithImage from '../assets/mary_s.jpg';

const TestimonialsSection = () => {
  const testimonial = {
    image: bobSmithImage,
    quote:
      'We run leagues, camps, and club teams across Chicago. With Go4, I post all my offerings in one place, hire athletic trainers from my phone, and remove a major task from my plate.',
    name: 'Amanda Kammes',
    title: 'CEO, Lakeshore Lacrosse',
  };

  return (
    <section id="testimonials" className="testimonials-section scroll-animate fade-in">
      <article className="testimonial scroll-animate scale-up stagger-1">
        <figure className="testimonial__figure">
          <img src={testimonial.image} alt={testimonial.name} className="testimonial__image" />
        </figure>
        <blockquote className="testimonial__quote">&ldquo;{testimonial.quote}&rdquo;</blockquote>
        <cite className="testimonial__attribution">
          {testimonial.name}, {testimonial.title}
        </cite>
      </article>
    </section>
  );
};

export default TestimonialsSection;
